import script from "./CMastersQualificationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CMastersQualificationInfo.vue?vue&type=script&setup=true&lang=ts"

import "./CMastersQualificationInfo.vue?vue&type=style&index=0&id=719ff5b6&lang=less"

const __exports__ = script;

export default __exports__